import styled from 'styled-components'
import { GREY_DARK } from '../../utils/colors'

export const UploadAvatarContainer = styled.div`
  margin: 36px 0px;
  display: flex;

  align-items: center;

  .user {
    flex: 1;
    margin-left: 43px;

    h4 {
      margin-bottom: 10px;
    }

    p {
      font-size: 18px;
      line-height: 1.44;
      color: ${GREY_DARK};
      margin-bottom: 18px;
    }

    span {
      font-size: 12px;
      line-height: 2.17;
      color: ${GREY_DARK};
    }
  }
`

export const Buttons = styled.div`
  padding-top: 36px;
`
